import i18next from "i18next";
import { i18n } from "locales/i18n";

// Create the "Show All" option
export const allEditorOption = {
  label: i18next.t("COMMON.TEXT.ALL"),
  value: "all",
};
